var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 17.8",
    style: {
      enableBackground: "new 0 0 20 17.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,14.3c-0.5-1-1.2-2.2-1.9-3.4c-0.7-1.3-1.3-2.3-1.8-3.4c-1.1-2-2.7-4.7-4-6.5C11.6,0.5,10.8,0,10,0 S8.4,0.4,8,1.1C6.7,2.9,5.2,5.6,4,7.6c-1.2,2.1-2.8,4.8-3.7,6.7C-0.1,15,0,15.9,0.3,16.6c0.5,0.7,1.2,1.1,2,1.2c2.2,0.1,5.3,0,7.6,0 c2.3,0,5.4,0,7.6,0c0.8,0,1.6-0.4,2-1.2C20,15.9,20.1,15,19.8,14.3z M11,14.9c0,0.5-0.4,1-1,1s-1-0.4-1-1V10c0-0.5,0.4-1,1-1 s1,0.4,1,1V14.9z M10,7.6C9.4,7.6,8.8,7,8.8,6.4S9.4,5.2,10,5.2s1.2,0.6,1.2,1.2S10.6,7.6,10,7.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInfoIcon);
export default __webpack_public_path__ + "static/media/chat_info_icon.bc6f4e00920847edb7d84b8219730fc0.svg";
export { ForwardRef as ReactComponent };